import {VehicleDataProvider} from "../api/generated";

interface HasVehicleDataProvider {
    vehicleDataProvider?: VehicleDataProvider;
}

export const getAssistantLocationsByVehicleDataProvider = <T extends HasVehicleDataProvider>(
    selectedLocations: T[] | null | undefined,
    vehicleDataProvider: VehicleDataProvider
): T[] => {
    return (selectedLocations || []).filter((location) => location.vehicleDataProvider === vehicleDataProvider);
}

export const hasAssistantVehicleDataProvider = <T extends HasVehicleDataProvider>(
    selectedLocations?: T[] | null
): boolean => {
    return (selectedLocations || []).some((location) =>
        location.vehicleDataProvider != null && location.vehicleDataProvider !== VehicleDataProvider.NoProvider
    );
}

export const getAssistantVehicleDataProvider = <T extends HasVehicleDataProvider>(
    selectedLocations?: T[] | null
): VehicleDataProvider | undefined => {
    if (!selectedLocations || selectedLocations.length === 0) {
        return undefined;
    }

    const hasMissingProvider = selectedLocations.some((location) => location.vehicleDataProvider == null);
    if (hasMissingProvider) {
        return undefined;
    }

    const providers = selectedLocations
        .map((location) => location.vehicleDataProvider)
        .filter((provider): provider is VehicleDataProvider =>
            provider != null && provider !== VehicleDataProvider.NoProvider
        );

    if (providers.length === 0) {
        return undefined;
    }

    const firstProvider = providers[0];
    return providers.every((provider) => provider === firstProvider) ? firstProvider : undefined;
}

export const isAssistantPipelineSearchProvider = <T extends HasVehicleDataProvider>(
    selectedLocations?: T[] | null
): boolean => getAssistantVehicleDataProvider(selectedLocations) === VehicleDataProvider.KeyloopPipelineSearch;
